<div class="container">
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          {{temperatureObject?.sensorDescription}}
        </h1>
      </div>
    </div>
  </section>
</div>

@if (loadError) {
  <p class="has-text-danger has-text-centered">Temperaturdata kunde inte hämtas just nu.</p>
} @else if (isLoading && (!lineChartData.datasets || lineChartData.datasets.length === 0)) {
  <p class="has-text-grey has-text-centered">Hämtar temperaturdata...</p>
}

<nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Temperatur</p>
      <p class="title">
        {{temperatureObject?.sensorValue}} °C
      </p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Datum</p>
      <p class="title">{{$safeNavigationMigration(temperatureObject?.sensorReadingDate) | date:'dd/MM HH:mm'}}</p>
    </div>
  </div>
</nav>

<nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Min</p>
      <p class="heading">
        {{temperatureExtremes?.minTemp}} °C &#64; {{$safeNavigationMigration(temperatureExtremes?.minTempTime) | date:'dd/MM HH:mm'}}
      </p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Max</p>
      <p class="heading">
        {{temperatureExtremes?.maxTemp}} °C &#64; {{$safeNavigationMigration(temperatureExtremes?.maxTempTime) | date:'dd/MM HH:mm'}}
      </p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Avg</p>
      <p class="heading">
        {{temperatureExtremes?.avgTemp}} °C
      </p>
    </div>
  </div>
</nav>

<div class="columns is-mobile">
  <div class="column is-10 is-offset-1">
    @if (lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0) {
      <canvas baseChart width="400" height="200" [data]="lineChartData" [options]="lineChartOptions" [plugins]="chartPlugins" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
      </canvas>
    }
  </div>
</div>

<div class="column is-10 is-offset-1">
  <a [routerLink]="['/temperature/history/', sensorId]">Historik</a>
</div>
